import SessionTimeout from "components/authentication/portal/SessionTimeout";
import AppInsightWrapper from "components/shared/AppInsightsWrapper";
import LoginContainer from "containers/portal/authentication/LoginContainer";
import SessionLoginContainer from "containers/session/authentication/LoginContainer";
import UriErrorContainer from "containers/session/UriErrorContainer";
import * as React from "react";
import { Route, Router, Switch } from "react-router-dom";
import { Container } from "reactstrap";
import Overlay from "./components/shared/Overlay";
import SessionResetContainer from "./containers/session/SessionResetContainer";
import RetrievalsCallbackContainer from "./containers/shared/RetrievalsCallbackContainer";
import "./styles/marble.scss";
import history from "./utils/history";

const SessionSubRoute = React.lazy(() => import("./subroutes/SessionSubRoute"));
const PortalSubRoute = React.lazy(() => import("./subroutes/PortalSubRoute"));

const App = () => {
  return (
    <AppInsightWrapper>
      <React.Suspense fallback={<Overlay showLoading />}>
        <Container fluid className="pe-0 ps-0 h-100">
          <Router history={history}>
            <Switch>
              <Route exact path="/" component={LoginContainer} />
              <Route
                path="/retrievals-callback"
                component={RetrievalsCallbackContainer}
              />
              <Route
                exact
                path={`/session/urierror`}
                component={UriErrorContainer}
              />
              <Route
                exact
                path={`/session/login`}
                component={SessionLoginContainer}
              />
              <Route path="/session-reset" component={SessionResetContainer} />
              <Route path="/session/:sessionId" component={SessionSubRoute} />
              <Route path="/me" component={PortalSubRoute} />
              <Route path="/timeout" component={SessionTimeout} />
            </Switch>
          </Router>
        </Container>
      </React.Suspense>
    </AppInsightWrapper>
  );
};

export default App;
